import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarWidth: (() => {
    const storedWidth = localStorage.getItem("sidebarWidth");
    return storedWidth && !isNaN(parseInt(storedWidth, 10))
      ? parseInt(storedWidth, 10)
      : 350;
  })(),
  isCollapsed: JSON.parse(localStorage.getItem("collapsedMenu") ?? "false"),
};

const sidebarSlice = createSlice({
  name: "sidebarSlice",
  initialState,
  reducers: {
    setSidebarWidth: (state, { payload }) => {
      state.sidebarWidth = payload;

      localStorage.setItem("sidebarWidth", payload);
    },
    toggleSidebarCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
      localStorage.setItem("collapsedMenu", JSON.stringify(state.isCollapsed));
    },
  },
});

export const { setSidebarWidth, toggleSidebarCollapse } = sidebarSlice.actions;

export default sidebarSlice.reducer;
